import "./loaderspinner.css"
export default function LoadingSpinner(){
    return(
        <div class="loader"></div>
    )
}